import React, { useEffect, useState } from "react";
import DesktopMenu from "../../../common/DesktopMenu/index";
import MobileMenu from "../../../common/MobileMenu/index";
import useWindowSize from "../../../common/windowSize";
import NewFooter from "../../../common/NewFooter";
import NoProduct from "../GenericComponents/NoItems";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { getCookie } from "../../../utils/cookie";
import { 
  Background, 
} from "../../../common/Faq/styles";
import {
  SettingsHeader,
  Title
} from '../styles';
import BackButton from "../../Products/BackButton";
import { toast } from "react-toastify";
import { publicAPI, privateAPI } from "../../../utils/api";
import FavoriteProduct from '../GenericComponents/FavoriteProduct';

const Favorites = () => {
  const [userID] = useState(getCookie('userId'));
  const size = useWindowSize();
  const [mobileMenu, setMobileMenu] = useState(false);
  const [userFavorites, setUserFavorites] = useState([]);
  const [loading, setLoading] = useState(false);

  const getUserFavorites = async () => {
    setLoading(true);
    try {
      const favoriteResponse = await privateAPI.get(`/auth/bacchus/client/user/favourite/${userID}`);
      let listOfFavoriteProducts = [];

      if (favoriteResponse.data.length === 0) {
        setUserFavorites(listOfFavoriteProducts);
      } else {
        const result = favoriteResponse.data.map(async (item) => {
            const product = await publicAPI.get(`/public/bacchus/product/${item.productFavId}`);
            listOfFavoriteProducts.push(product.data);
          })
        await Promise.all(result);
        setUserFavorites(listOfFavoriteProducts);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request && error.request.status === 500) {
        return toast.error("Internal server error");
      }
    }
  };

  useEffect(() => {
    getUserFavorites();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <React.Fragment>
      {mobileMenu ? <MobileMenu single={true}/> : <DesktopMenu single={true}/> }
      <Background marginTop adminPanel>
        <SettingsHeader>
          <BackButton userPanel/>
          <Title>
            Favorites
          </Title>
        </SettingsHeader>
        {userFavorites.length === 0 ? 
          <NoProduct/>
          :
          <FavoriteProduct
            userFavorites={userFavorites}
            getUserFavorites={getUserFavorites}/>
        }
      </Background>
      <NewFooter />
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};

export default Favorites;
